<div *ngFor="let msg of messages; let i = index">
  <div class="divider" *ngIf="showDate(msg.sentAt, i)">
      <span>{{msg.sentAt | localeDate: 'dddd, D MMMM' | titlecase}}</span>
  </div>
  <tlm-msg (setDelivery)="setDelivey($event)" [userId]="userId" [msg]="msg" [ticket]="ticket"></tlm-msg>
</div>

<div *ngIf="!messages.length">
  <h5>Nessun messaggio trovato per questa chat</h5>
</div>

<div *ngIf="sendingStatus" class="fake-message" style="text-align: right" >
  <mat-progress-bar color="primary" mode="indeterminate" value="50" bufferValue="100"></mat-progress-bar>
</div>

